/**
 * InsCoder WANG.J 2026-09-09 B + Wholesale quick shop product info tabs: click / arrow-key switching
 */
(function () {
  'use strict';

  var TAB_BTN_SELECTOR = '.cus-Wholesale-quick-shop .product-tabs__btn';

  function activateTab(btn) {
    var nav = btn.closest('.product-tabs__nav');
    if (!nav) return;

    var wrap = nav.closest('.product-tabs__wrap');
    var panelId = btn.getAttribute('aria-controls');

    nav.querySelectorAll('.product-tabs__btn').forEach(function (tabBtn) {
      var isActive = tabBtn === btn;
      tabBtn.classList.toggle('is-active', isActive);
      tabBtn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (wrap) {
      wrap.querySelectorAll('.product-tabs__panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === panelId);
      });
    }
  }

  // Event delegation: the quick-view content is injected dynamically on every open,
  // so bind once on document instead of per-render.
  var state = window.__qsWholesaleQuickShopState || (window.__qsWholesaleQuickShopState = {});
  var FoxTheme = window.FoxTheme;
  if (!state.tabsInited) {
    state.tabsInited = true;

    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest(TAB_BTN_SELECTOR) : null;
      if (!btn) return;
      activateTab(btn);
    });

    // ARIA tabs keyboard support: ArrowLeft / ArrowRight cycle through tabs.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      var btn = event.target && event.target.closest ? event.target.closest(TAB_BTN_SELECTOR) : null;
      if (!btn) return;

      var nav = btn.closest('.product-tabs__nav');
      if (!nav) return;

      var tabs = Array.prototype.slice.call(nav.querySelectorAll('.product-tabs__btn'));
      var index = tabs.indexOf(btn);
      if (index < 0) return;

      var nextIndex =
        event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;

      event.preventDefault();
      tabs[nextIndex].focus();
      activateTab(tabs[nextIndex]);
    });
  }
})();
/**
 * InsCoder WANG.J 2026-09-09 E + Wholesale quick shop product info tabs: click / arrow-key switching
 */

/**
 * InsCoder WANG.J 2026-09-09 B + Wholesale quick shop sticky ATC bar sync: price / save / availability
 */
(function () {
  'use strict';

  var BAR_SELECTOR = '[data-qs-sticky-atc]';
  var SHOP_SELECTOR = '.cus-Wholesale-quick-shop';
  var state = window.__qsWholesaleQuickShopState || (window.__qsWholesaleQuickShopState = {});
  var FoxTheme = window.FoxTheme;

  function formatMoney(value) {
    if (typeof value !== 'number') return '';
    if (
      window.FoxTheme &&
      FoxTheme.Currency &&
      typeof window.FoxTheme.Currency.formatMoney === 'function' &&
      FoxTheme.settings &&
      window.FoxTheme.settings.moneyFormat
    ) {
      return window.FoxTheme.Currency.formatMoney(value, window.FoxTheme.settings.moneyFormat);
    }
    return '$' + (value / 100).toFixed(2);
  }

  function stringOr(text, fallback) {
    return text && text.length ? text : fallback;
  }

  function parseTierRange(title) {
    if (!title || typeof title !== "string") return null;
    var str = title.trim();

    // 1. Plus / open-ended formats: "20+ pcs", "20 + pcs", "20+", ">= 20", "≥ 20", "20 and up", "20 and more", "pcs+", "pc+"
    var plusMatch =
      str.match(/(?:>=|≥)\s*(\d+)/i) ||
      str.match(/(\d+)\s*(?:\+|and\s+up|and\s+more|pcs\+|pc\+)/i) ||
      str.match(/(\d+)\s*\+/);
    if (plusMatch) {
      return { min: parseInt(plusMatch[1], 10), max: Infinity, isPlus: true };
    }

    // 2. Range formats: "3 - 9 pcs", "3-9", "3 to 9 pcs", "3 ~ 9"
    var rangeMatch = str.match(/(\d+)\s*(?:-|to|~)\s*(\d+)/i);
    if (rangeMatch) {
      return {
        min: parseInt(rangeMatch[1], 10),
        max: parseInt(rangeMatch[2], 10),
        isRange: true
      };
    }

    // 3. Single count formats: "2 pcs", "2pcs", "2 pc", "2 items", "2 units", "2 pieces", "2"
    var singleMatch =
      str.match(/^(\d+)\s*(?:pcs|pc|pieces?|items?|units?)?\.?$/i) ||
      str.match(/(\d+)\s*(?:pcs|pc|pieces?|items?|units?)/i) ||
      str.match(/(\d+)/);
    if (singleMatch) {
      var count = parseInt(singleMatch[1], 10);
      return { min: count, max: count, isSingle: true };
    }

    return null;
  }

  function getModalTiers(modal) {
    if (!modal) return [];
    var items = modal.querySelectorAll(".product-card__list-pices-item");
    var tiers = [];
    items.forEach(function (item) {
      var titleEl = item.querySelector(".product-card__list-pices-item-title");
      var title = item.getAttribute("data-tier-title") || (titleEl ? titleEl.textContent.trim() : "");
      var valEl = item.querySelector("[data-tier-discount-percent]");
      var pct = Number(
        item.getAttribute("data-tier-discount-percent") ||
          (valEl ? valEl.getAttribute("data-tier-discount-percent") : 0)
      );
      if (isNaN(pct) || pct < 0) pct = 0;
      var range = parseTierRange(title);
      if (range) {
        tiers.push({
          min: range.min,
          max: range.max,
          isSingle: !!range.isSingle,
          isPlus: !!range.isPlus,
          isRange: !!range.isRange,
          percent: pct,
          title: title,
          element: item
        });
      }
    });

    // Auto-resolve upper bounds for single numbers (e.g. "2 pcs") based on next tier
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].isSingle) {
        var nextTierMin = Infinity;
        for (var j = i + 1; j < tiers.length; j++) {
          if (tiers[j].min > tiers[i].min) {
            nextTierMin = tiers[j].min;
            break;
          }
        }
        if (nextTierMin < Infinity) {
          tiers[i].max = nextTierMin - 1;
        } else if (i === tiers.length - 1) {
          tiers[i].max = Infinity;
        }
      }
    }

    return tiers;
  }

  function getDiscountPercent(modal, variant, qty) {
    var tiers = getModalTiers(modal);
    if (!tiers.length) return 0;

    var currentQty = typeof qty === "number" && qty > 0 ? qty : 1;

    // 1. Direct match within range [min, max]
    var matchedTiers = tiers.filter(function (t) {
      return currentQty >= t.min && currentQty <= t.max;
    });
    if (matchedTiers.length > 0) {
      matchedTiers.sort(function (a, b) {
        return b.percent - a.percent;
      });
      return matchedTiers[0].percent;
    }

    // 2. If qty exceeds ranges, pick tier with currentQty >= min and highest discount
    var lowerTiers = tiers.filter(function (t) {
      return currentQty >= t.min;
    });
    if (lowerTiers.length > 0) {
      lowerTiers.sort(function (a, b) {
        return b.percent - a.percent;
      });
      return lowerTiers[0].percent;
    }

    // 3. If qty is less than lowest tier min (e.g. qty = 1), default to Tier 1 discount
    return tiers[0].percent;
  }

  function applyStickyVariant(bar, variant, qty) {
    if (!bar) return;

    var total = qty > 0 ? qty : 1;
    var priceText = bar.querySelector("[data-qs-price-text]");
    var compareText = bar.querySelector("[data-qs-compare-text]");
    var saveText = bar.querySelector("[data-qs-save-text]");
    var addButton = bar.querySelector("[data-qs-atc]");
    var addText = bar.querySelector("[data-qs-atc-text]");
    var shopButton = bar.querySelector("[data-qs-shop-now]");
    var shopText = bar.querySelector("[data-qs-shop-now-text]");
    var variantInput = bar.querySelector('input[name="id"]');
    var modal = bar.closest("quick-view-modal");

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute("disabled", "disabled");
        addButton.setAttribute("aria-disabled", "true");
        addButton.classList.add("is-disabled");
        if (addText) {
          addText.textContent = stringOr(
            window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.unavailable,
            "Unavailable"
          );
        }
      }
      if (shopButton) {
        shopButton.disabled = true;
        shopButton.setAttribute("disabled", "disabled");
        shopButton.setAttribute("aria-disabled", "true");
        shopButton.classList.add("is-disabled");
        if (shopText) {
          shopText.textContent = stringOr(
            window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.unavailable,
            "Unavailable"
          );
        }
      }
      return;
    }

    var unitOriginal = Number(variant.price);
    var discountPercent = getDiscountPercent(modal, variant, total);
    var available = variant.available !== false;

    if (discountPercent > 0) {
      var unitDiscounted = Math.round((unitOriginal * (100 - discountPercent)) / 100);
      var totalOriginal = unitOriginal * total;
      var totalDiscounted = unitDiscounted * total;

      if (priceText) {
        priceText.textContent = formatMoney(totalDiscounted);
        priceText.classList.add("qs-sticky-atc__price--on-sale");
      }
      if (compareText) {
        compareText.textContent = formatMoney(totalOriginal);
        compareText.hidden = false;
      }
      if (saveText) {
        saveText.textContent = "Save " + discountPercent + "%";
        saveText.hidden = false;
      }
      bar.setAttribute("data-qs-price", String(totalDiscounted));
      bar.setAttribute("data-qs-compare-price", String(totalOriginal));
    } else {
      var price = unitOriginal * total;
      var compare = variant.compare_at_price ? Number(variant.compare_at_price) * total : 0;
      var onSale = compare > price;

      if (priceText) {
        priceText.textContent = formatMoney(price);
        priceText.classList.toggle("qs-sticky-atc__price--on-sale", onSale);
      }
      if (compareText) {
        if (onSale) {
          compareText.textContent = formatMoney(compare);
          compareText.hidden = false;
        } else {
          compareText.textContent = "";
          compareText.hidden = true;
        }
      }
      if (saveText) {
        if (onSale) {
          var pct = Math.round(((compare - price) / compare) * 100);
          saveText.textContent = "Save " + pct + "%";
          saveText.hidden = false;
        } else {
          saveText.textContent = "";
          saveText.hidden = true;
        }
      }
      bar.setAttribute("data-qs-price", String(price));
      if (onSale) {
        bar.setAttribute("data-qs-compare-price", String(compare));
      } else {
        bar.removeAttribute("data-qs-compare-price");
      }
    }

    if (addButton) {
      if (available) {
        addButton.disabled = false;
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButton.classList.remove("is-disabled");
        if (addText) {
          addText.textContent = stringOr(
            window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.addToCart,
            "Add to cart"
          );
        }
      } else {
        addButton.disabled = true;
        addButton.setAttribute("disabled", "disabled");
        addButton.setAttribute("aria-disabled", "true");
        addButton.classList.add("is-disabled");
        if (addText) {
          addText.textContent = stringOr(
            window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.soldOut,
            "Sold out"
          );
        }
      }
    }

    if (shopButton) {
      if (available) {
        shopButton.disabled = false;
        shopButton.removeAttribute("disabled");
        shopButton.removeAttribute("aria-disabled");
        shopButton.classList.remove("is-disabled");
        if (shopText) {
          shopText.textContent = stringOr(
            bar.getAttribute("data-qs-shop-now-label"),
            "Shop Now"
          );
        }
      } else {
        shopButton.disabled = true;
        shopButton.setAttribute("disabled", "disabled");
        shopButton.setAttribute("aria-disabled", "true");
        shopButton.classList.add("is-disabled");
        if (shopText) {
          shopText.textContent = stringOr(
            window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.soldOut,
            "Sold out"
          );
        }
      }
    }

    if (variantInput) {
      variantInput.value = String(variant.id);
    }

    bar.setAttribute("data-qs-variant-id", String(variant.id));
  }

  function getQuantity(modal) {
    if (!modal) return 1;
    var input = modal.querySelector("[data-qs-qty]") || modal.querySelector("[data-qs-qty-sync]");
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function applyPriceBlock(modal, variant, qty) {
    if (!modal || !variant) return;

    var priceWrap =
      modal.querySelector(".product__block--price .f-price") ||
      modal.querySelector('[id^="price-"] .f-price') ||
      modal.querySelector(".f-price");
    if (!priceWrap) return;

    // Quantity price breaks render a range ("from $X to $Y") that must not be multiplied.
    if (modal.querySelector('[id^="VolumeNote-"]')) return;

    var unitOriginal = Number(variant.price);
    if (isNaN(unitOriginal) || unitOriginal <= 0) return;

    var currentQty = typeof qty === "number" && qty > 0 ? qty : 1;
    var discountPercent = getDiscountPercent(modal, variant, currentQty);

    if (discountPercent > 0) {
      var unitDiscounted = Math.round((unitOriginal * (100 - discountPercent)) / 100);
      var totalOriginal = unitOriginal * currentQty;
      var totalDiscounted = unitDiscounted * currentQty;

      priceWrap.classList.add("f-price--on-sale");
      if (variant.available === false) {
        priceWrap.classList.add("f-price--sold-out");
      } else {
        priceWrap.classList.remove("f-price--sold-out");
      }

      var saleWrap = priceWrap.querySelector(".f-price__sale");
      if (!saleWrap) {
        saleWrap = document.createElement("div");
        saleWrap.className = "f-price__sale";
        priceWrap.appendChild(saleWrap);
      }

      var saleItem = saleWrap.querySelector(".f-price-item--sale");
      if (!saleItem) {
        saleItem = document.createElement("span");
        saleItem.className = "f-price-item f-price-item--sale";
        saleWrap.prepend(saleItem);
      }
      saleItem.textContent = formatMoney(totalDiscounted);

      var regularWrap = saleWrap.querySelector(".f-price-item--regular");
      if (!regularWrap) {
        regularWrap = document.createElement("span");
        regularWrap.className = "f-price-item f-price-item--regular";
        saleWrap.appendChild(regularWrap);
      }
      var strikeEl = regularWrap.querySelector("s");
      if (!strikeEl) {
        strikeEl = document.createElement("s");
        regularWrap.appendChild(strikeEl);
      }
      strikeEl.textContent = formatMoney(totalOriginal);

      var badge = saleWrap.querySelector(".f-badge--sale");
      if (!badge) {
        badge = document.createElement("div");
        badge.className = "f-badge f-badge--sale";
        saleWrap.appendChild(badge);
      }
      badge.textContent = "Save " + discountPercent + "%";
      badge.hidden = false;

      var baseRegular = priceWrap.querySelector(".f-price__regular .f-price-item--regular");
      if (baseRegular) {
        baseRegular.textContent = formatMoney(totalDiscounted);
      }
    } else {
      var compare = variant.compare_at_price ? Number(variant.compare_at_price) : 0;
      var onSale = compare > unitOriginal;
      var regular = priceWrap.querySelector(".f-price__regular .f-price-item--regular");
      var sale = priceWrap.querySelector(".f-price__sale .f-price-item--sale");
      var saleCompare = priceWrap.querySelector(".f-price__sale .f-price-item--regular s");

      if (onSale) {
        priceWrap.classList.add("f-price--on-sale");
        if (sale) sale.textContent = formatMoney(unitOriginal * currentQty);
        if (saleCompare) saleCompare.textContent = formatMoney(compare * currentQty);
      } else {
        priceWrap.classList.remove("f-price--on-sale");
        if (regular) regular.textContent = formatMoney(unitOriginal * currentQty);
      }
    }
  }

  function syncQuantity(modal, variant) {
    if (!modal) return;
    var pill = modal.querySelector("[data-qs-qty]");
    var mirror = modal.querySelector("[data-qs-qty-sync]");
    if (!pill && !mirror) return;

    var rule = (variant && variant.quantity_rule) || {};
    var min = rule.min ? Number(rule.min) : 1;
    var step = rule.increment ? Number(rule.increment) : 1;
    var hasMax = rule.max !== null && rule.max !== undefined && rule.max !== "";
    var max = hasMax ? Number(rule.max) : null;

    if (pill) {
      pill.min = String(min);
      pill.step = String(step);
      pill.setAttribute("data-min", String(min));
      if (pill.dataset) pill.dataset.min = String(min);
      if (hasMax) {
        pill.max = String(max);
        pill.setAttribute("data-max", String(max));
        if (pill.dataset) pill.dataset.max = String(max);
      } else {
        pill.removeAttribute("max");
        pill.removeAttribute("data-max");
        if (pill.dataset) delete pill.dataset.max;
      }

      var current = Number(pill.value) || min;
      var next = current;
      if (next < min) next = min;
      if (hasMax && next > max) next = max;
      if (next !== current) {
        pill.value = String(next);
        pill.dispatchEvent(new Event("change", { bubbles: true }));
      } else if (mirror) {
        mirror.value = pill.value;
      }
    } else if (mirror) {
      mirror.value = String(min);
    }
  }

  function applyTierPrices(modal, variant, qty) {
    if (!modal || !variant) return;
    var price = Number(variant.price);
    if (isNaN(price) || price <= 0) return;

    var currentQty = typeof qty === "number" && qty > 0 ? qty : getQuantity(modal);
    var tiers = getModalTiers(modal);
    var activeFound = false;

    tiers.forEach(function (t) {
      var item = t.element;
      var valNode = item ? item.querySelector(".product-card__list-pices-item-discount-value") : null;
      var pct = t.percent;

      if (valNode && !isNaN(pct) && pct >= 0) {
        var discountedPrice = Math.round((price * (100 - pct)) / 100);
        var eachSuffix = valNode.getAttribute("data-tier-each-text") || "Each";
        valNode.textContent = formatMoney(discountedPrice) + (eachSuffix ? " " + eachSuffix : "");
      }

      var isMatch = currentQty >= t.min && currentQty <= t.max;
      if (isMatch) {
        activeFound = true;
      }
      if (item) {
        item.classList.toggle("is-active-tier", isMatch);
      }
    });

    var lowestMin = tiers.length > 0 ? tiers[0].min : 1;
    if (!activeFound && tiers.length > 0 && currentQty < lowestMin && tiers[0].element) {
      tiers[0].element.classList.add("is-active-tier");
    }
  }

  function applyTotals(modal, variant) {
    if (!modal) return;

    modal.__qsVariant = variant;

    var qty = getQuantity(modal);
    applyPriceBlock(modal, variant, qty);
    applyTierPrices(modal, variant, qty);
    modal.querySelectorAll(BAR_SELECTOR).forEach(function (bar) {
      applyStickyVariant(bar, variant, qty);
    });

    syncQuantity(modal, variant);

    if (variant) {
      var productInfo = modal.querySelector("product-info");
      if (productInfo && typeof productInfo.updateMedia === "function") {
        productInfo.updateMedia(variant, { preventScroll: true });
      }
    }
  }

  function getVariantData(modal) {
    var node = modal && modal.querySelector('.quick-view__content [data-qs-variants]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptions(modal) {
    if (!modal) return [];
    var options = [];

    // Each option group is either a fieldset (for buttons/swatches) or div.product-form__input (for dropdowns)
    var groups = modal.querySelectorAll('variant-selects fieldset, variant-selects div.product-form__input');
    if (groups.length) {
      groups.forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          options.push(checked.value.trim());
          return;
        }
        var select = group.querySelector('select');
        if (select && select.value) {
          options.push(select.value.trim());
        }
      });
    }

    if (!options.length) {
      modal.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (r) {
        options.push(r.value.trim());
      });
    }

    if (!options.length) {
      modal.querySelectorAll('variant-selects select').forEach(function (sel) {
        if (sel.value) {
          options.push(sel.value.trim());
        }
      });
    }

    return options;
  }

  function optionsMatch(valA, valB) {
    if (valA === valB) return true;
    if (valA == null || valB == null) return false;
    return String(valA).trim().toLowerCase() === String(valB).trim().toLowerCase();
  }

  function findVariantByOptions(variants, selectedOptions) {
    if (!variants || !variants.length || !selectedOptions || !selectedOptions.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      if (Array.isArray(v.options)) {
        if (v.options.length < selectedOptions.length) {
          match = false;
        } else {
          for (var j = 0; j < selectedOptions.length; j++) {
            if (selectedOptions[j] && !optionsMatch(v.options[j], selectedOptions[j])) {
              match = false;
              break;
            }
          }
        }
      } else {
        if (selectedOptions[0] && !optionsMatch(v.option1, selectedOptions[0])) match = false;
        if (selectedOptions[1] && !optionsMatch(v.option2, selectedOptions[1])) match = false;
        if (selectedOptions[2] && !optionsMatch(v.option3, selectedOptions[2])) match = false;
      }
      if (match) return v;
    }
    return null;
  }

  function getInitialVariant(modal, variants) {
    if (!variants.length) return null;

    var idInput = modal && modal.querySelector('.quick-view__content input.product-variant-id, .quick-view__content [data-qs-sticky-atc] input[name="id"]');
    var preferId = idInput && Number(idInput.value);
    if (preferId) {
      var match = variants.filter(function (item) {
        return Number(item.id) === preferId;
      })[0];
      if (match) return match;
    }

    var available = variants.filter(function (item) {
      return item.available !== false;
    })[0];
    return available || variants[0];
  }

  function getCurrentVariant(modal) {
    if (!modal) return null;
    var variants = getVariantData(modal);
    if (!variants.length) return null;

    // 1. Match by currently selected options in variant-selects
    var selectedOptions = getSelectedOptions(modal);
    if (selectedOptions.length) {
      var matched = findVariantByOptions(variants, selectedOptions);
      if (matched) {
        modal.__qsVariant = matched;
        return matched;
      }
    }

    // 2. Check for [data-selected-variant] script tag if present
    var script = modal.querySelector('variant-selects script[data-selected-variant]');
    if (script && script.textContent) {
      try {
        var fromScript = JSON.parse(script.textContent);
        if (fromScript && fromScript.id) {
          var matchById = variants.filter(function (item) {
            return Number(item.id) === Number(fromScript.id);
          })[0];
          if (matchById) {
            modal.__qsVariant = matchById;
            return matchById;
          }
        }
      } catch (e) {}
    }

    // 3. Fallback to cached or initial variant
    if (!modal.__qsVariant) {
      modal.__qsVariant = getInitialVariant(modal, variants);
    }
    return modal.__qsVariant;
  }

  function handleQuantityChange(input) {
    if (!input.closest(SHOP_SELECTOR)) return;
    var modal = input.closest('quick-view-modal');
    if (!modal) return;

    var mirror = modal.querySelector('[data-qs-qty-sync]');
    if (mirror) mirror.value = input.value;

    applyTotals(modal, getCurrentVariant(modal));
  }

  function getShopModals() {
    var modals = [];
    document.querySelectorAll('.quick-view__content ' + SHOP_SELECTOR).forEach(function (root) {
      var modal = root.closest('quick-view-modal');
      if (modal && modals.indexOf(modal) === -1) modals.push(modal);
    });
    return modals;
  }

  function syncTotals() {
    getShopModals().forEach(function (modal) {
      delete modal.__qsVariant;
      applyTotals(modal, getCurrentVariant(modal));
    });
  }

  // Handle immediate option change on variant-selects (radio clicks, dropdown select)
  function handleVariantOptionChange(target) {
    var modal = target.closest('quick-view-modal');
    if (!modal) return;

    if (target.type === 'radio') {
      var wrap = target.closest('.product-form__input, fieldset');
      if (wrap) {
        var valLabel = wrap.querySelector('[data-selected-swatch-value], [data-selected-value]');
        if (valLabel) valLabel.textContent = target.value;
      }
    }

    delete modal.__qsVariant;
    var variant = getCurrentVariant(modal);

    if (variant) {
      applyTotals(modal, variant);
    }
  }

  if (!state.stickyAtcInited) {
    state.stickyAtcInited = true;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches && target.matches('[data-qs-qty]')) {
        handleQuantityChange(target);
        return;
      }

      if (target.closest && target.closest('variant-selects')) {
        handleVariantOptionChange(target);
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.closest && target.closest('variant-selects')) {
        var radio = target.matches && target.matches('input[type="radio"]')
          ? target
          : target.closest('label')
            ? target.closest('label').querySelector('input[type="radio"]') || target.closest('label').control
            : null;
        if (radio) {
          handleVariantOptionChange(radio);
        }
      }
    });

    document.addEventListener('input', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches && target.matches('[data-qs-qty]')) {
        handleQuantityChange(target);
      }
    });

    // Content injection happens per open (quick-view.js re-renders .quick-view__content)
    document.addEventListener('quick-view:loaded', syncTotals);
    document.addEventListener('quick-view:open', syncTotals);

    // Keep totals in sync if theme dispatches variant:changed
    document.addEventListener('variant:changed', function (event) {
      var variant = event && event.detail && event.detail.variant;
      if (!variant) return;
      getShopModals().forEach(function (modal) {
        applyTotals(modal, variant);
      });
    });

    // Keep totals in sync if FoxTheme pubsub variantChange fires
    if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.sectionId || !data.variant) return;
        getShopModals().forEach(function (modal) {
          var info = modal.querySelector(SHOP_SELECTOR);
          if (info && info.dataset && info.dataset.section === data.sectionId) {
            applyTotals(modal, data.variant);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncTotals);
    }
  }

    if (!state.cartFetched) {
    state.cartFetched = true;
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    fetch(routesRoot + "cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        state.cart = cart;
      })
      .catch(function () {});
  }

  // Always run syncTotals when this script is loaded / injected
  syncTotals();
})();
/**
 * InsCoder WANG.J 2026-09-09 E + Wholesale quick shop sticky ATC bar sync: price / save / availability
 */

/**
 * Wholesale quick shop Add to Cart: AJAX add to cart, trigger cart drawer & count refresh
 */
(function () {
  'use strict';

  var ATC_SELECTOR = '[data-qs-atc]';
  var state = window.__qsWholesaleQuickShopState || (window.__qsWholesaleQuickShopState = {});
  var FoxTheme = window.FoxTheme;

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.classList.toggle('btn--loading', loading);
    btn.disabled = loading;
  }

  function showError(form, message) {
    var errorElement = form && form.querySelector('.product-form__error-message');
    if (errorElement) {
      errorElement.hidden = false;
      errorElement.textContent = message;
      return;
    }
    window.alert(message);
  }

  function handleAddToCart(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var form = btn.closest('form');
    var modal = btn.closest('quick-view-modal');
    if (!form && modal) {
      form = modal.querySelector('.qs-sticky-atc__form');
    }
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-qs-qty-sync]');
    var variant = modal && modal.__qsVariant;

    if (variant && variant.available === false) return;

    var variantId = (variant && variant.id) || (idInput && idInput.value);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    if (!variantId) return;

    setLoading(btn, true);

    var root = getRoutesRoot();
    var errorMessage = null;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: quantity
          }
        ]
      })
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            if (response.ok) {
              setLoading(btn, false);

              // 1. Notify theme about added product
              document.dispatchEvent(
                new CustomEvent('product-ajax:added', {
                  detail: { product: body }
                })
              );

              // 2. Fetch cart JSON and update cart state for theme subscribers (header cart count, etc.)
              fetch(root + 'cart.js')
                .then(function (res) {
                  return res.json();
                })
                .then(function (cart) {
                  if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
                    window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
                  }
                })
                .catch(function () {});

              // 3. Close the quick-view modal
              if (modal) {
                if (typeof modal.hide === 'function') {
                  modal.hide(true);
                } else {
                  modal.setAttribute('hidden', '');
                }
              }

              // 4. Trigger cart drawer refresh & open
              document.dispatchEvent(
                new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: { open: true }
                })
              );
            } else {
              errorMessage =
                body.description ||
                body.message ||
                (window.FoxTheme && window.FoxTheme.cartStrings && window.FoxTheme.cartStrings.error) ||
                'Failed to add item to cart';
            }
          });
      })
      .catch(function () {
        errorMessage =
          (window.FoxTheme && window.FoxTheme.cartStrings && window.FoxTheme.cartStrings.error) ||
          'Failed to add item to cart';
      })
      .then(function () {
        if (!errorMessage) return;
        setLoading(btn, false);
        showError(form, errorMessage);
      });
  }

  if (state.atcInited) return;
  state.atcInited = true;

  // Delegated click on Add to Cart button
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest(ATC_SELECTOR) : null;
    if (!btn) return;

    event.preventDefault();
    handleAddToCart(btn);
  });

  // Prevent default form submit on sticky ATC form, routing through handleAddToCart
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('.qs-sticky-atc__form')) return;

    event.preventDefault();
    var atcBtn = form.querySelector(ATC_SELECTOR);
    if (atcBtn) {
      handleAddToCart(atcBtn);
    }
  });
})();

/**
 * InsCoder WANG.J 2026-09-09 B + Custom "Shop Now" buy-it-now: add current variant+qty to cart, then go to checkout
 */
(function () {
  'use strict';

  var SHOP_NOW_SELECTOR = '[data-qs-shop-now]';
  var state = window.__qsWholesaleQuickShopState || (window.__qsWholesaleQuickShopState = {});
  var FoxTheme = window.FoxTheme;

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.classList.toggle('btn--loading', loading);
    btn.disabled = loading;
  }

  function showError(form, message) {
    var errorElement = form && form.querySelector('.product-form__error-message');
    if (errorElement) {
      errorElement.hidden = false;
      errorElement.textContent = message;
      return;
    }
    window.alert(message);
  }

  if (state.shopNowInited) return;
  state.shopNowInited = true;

  // Delegated: quick-view content is re-injected on every open.
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest(SHOP_NOW_SELECTOR) : null;
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    var form = btn.closest('form');
    var modal = btn.closest('quick-view-modal');
    if (!form && modal) {
      form = modal.querySelector('.qs-sticky-atc__form');
    }
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-qs-qty-sync]');
    var variant = modal && modal.__qsVariant;

    if (variant && variant.available === false) {
      event.preventDefault();
      return;
    }

    var variantId = (variant && variant.id) || (idInput && idInput.value);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    if (!variantId) return;

    event.preventDefault();
    setLoading(btn, true);

    var root = getRoutesRoot();
    var errorMessage = null;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            if (response.ok) {
              window.location.href = root + 'checkout';
            } else {
              errorMessage =
                body.description ||
                body.message ||
                (window.FoxTheme && window.FoxTheme.cartStrings && window.FoxTheme.cartStrings.error) ||
                'Failed to checkout';
            }
          });
      })
      .catch(function () {
        errorMessage =
          (window.FoxTheme && window.FoxTheme.cartStrings && window.FoxTheme.cartStrings.error) ||
          'Failed to checkout';
      })
      .then(function () {
        if (!errorMessage) return;
        setLoading(btn, false);
        showError(form, errorMessage);
      });
  });
})();
/**
 * InsCoder WANG.J 2026-09-09 E + Custom "Shop Now" buy-it-now: add current variant+qty to cart, then go to checkout
 */
